export const Flags = {
    HideDashboardBackButton: "HideDashboardBackButton",
};
